import { ArrowLeft } from 'lucide-react'
import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { Logo } from './Logo'

/** Plain header + content column shared by the Terms and Privacy pages. Public, no auth chrome. */
export function LegalPageShell({
  title,
  updated,
  children,
}: {
  title: string
  updated: string
  children: ReactNode
}) {
  return (
    <div className="min-h-screen bg-cream-50 font-sans text-deep-900">
      <header className="border-b border-slate-200/70 bg-cream-50/90">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-3.5">
          <Link to="/" className="flex min-w-0 items-center" aria-label="YellowDots home">
            <Logo />
          </Link>
          <Link to="/register" className="inline-flex items-center gap-1.5 text-sm font-bold text-deep-900 transition hover:text-dot-600">
            <ArrowLeft size={15} /> Back to registration
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-10 sm:py-14">
        <h1 className="font-sans text-3xl font-extrabold tracking-tight text-deep-900 sm:text-4xl">{title}</h1>
        <p className="mt-2 text-sm text-ink-500">Last updated {updated}</p>
        <div className="prose-legal mt-8 space-y-6 text-[15px] leading-relaxed text-ink-700">
          {children}
        </div>
      </main>
    </div>
  )
}

/** One numbered section, consistent heading style for both documents. */
export function LegalSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section>
      <h2 className="text-lg font-bold text-deep-900">{title}</h2>
      <div className="mt-2 space-y-3">{children}</div>
    </section>
  )
}
